import {Component} from 'react'
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom'

import LoginForm from './components/LoginForm'
import Home from './components/Home'
import Products from './components/Products'
import ProductItemDetails from './components/ProductItemDetails'
import Cart from './components/Cart'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import CartContext from './context/CartContext'

import './App.css'

class App extends Component {
  state = {
    cartList: [],
  }

  addCartItem = product => {
    this.setState(prevState => {
      const {cartList} = prevState
      const isProductAlreadyPresent = cartList.find(
        cartItem => cartItem.id === product.id,
      )
      if (isProductAlreadyPresent) {
        const updatedCartList = cartList.map(cartItem => {
          if (cartItem.id === product.id) {
            console.log('same product exist')
            return product
          }
          return cartItem
        })
        console.log(updatedCartList)
        return {cartList: updatedCartList}
      }
      return {cartList: [...cartList, product]}
    })
  }

  deleteCartItem = id => {
    this.setState(prevState => {
      const {cartList} = prevState
      const filteresCartList = cartList.filter(cartItem => cartItem.id !== id)
      return {cartList: filteresCartList}
    })
  }

  incrementQuantity = id => {
    this.setState(prevState => {
      const {cartList} = prevState
      const updatedCartList = cartList.map(cartItem => {
        if (cartItem.id === id) {
          return {...cartItem, quantity: cartItem.quantity + 1}
        }
        return cartItem
      })
      return {cartList: updatedCartList}
    })
  }

  decrementQuantity = id => {
    this.setState(prevState => {
      const {cartList} = prevState
      const updatedCartList = cartList.map(cartItem => {
        if (cartItem.id === id) {
          const {quantity} = cartItem
          const updatedQuantity = quantity > 1 ? quantity - 1 : quantity
          return {...cartItem, quantity: updatedQuantity}
        }
        return cartItem
      })
      return {cartList: updatedCartList}
    })
  }

  emptyCartList = () => {
    this.setState({cartList: []})
  }

  render() {
    const {cartList} = this.state

    return (
      <BrowserRouter>
        <CartContext.Provider
          value={{
            cartList,
            addCartItem: this.addCartItem,
            deleteCartItem: this.deleteCartItem,
            incrementQuantity: this.incrementQuantity,
            decrementQuantity: this.decrementQuantity,
            emptyCartList: this.emptyCartList,
          }}
        >
          <Switch>
            <Route exact path="/login" component={LoginForm} />
            <ProtectedRoute exact path="/" component={Home} />
            <ProtectedRoute exact path="/products" component={Products} />
            <ProtectedRoute
              exact
              path="/products/:id"
              component={ProductItemDetails}
            />
            <ProtectedRoute exact path="/cart" component={Cart} />
            <Route path="/not-found" component={NotFound} />
            <Redirect to="not-found" />
          </Switch>
        </CartContext.Provider>
      </BrowserRouter>
    )
  }
}

export default App
